module.exports = __webpack_public_path__ + "templates/returnComponent.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/components/returnComponent/returnComponent.html
// module id = 365
// module chunks = 15